import React, { useEffect, useState } from "react";
import ModalBox from "../../Components/modals/ModalBox";
import { MakeAxiosRequest } from "../../utils/handler";
import { useDispatch, useSelector } from "react-redux";
import { switchProfile } from "../../features/authSlice";
import { useNavigate } from "react-router-dom";
import DetailsModal from "../Relationship/DetailsModal";
import { SwalError } from "../../Components/SwalFns";

function SelectUserModal({ showModal, closeModal }) {

  const dispatch = useDispatch();
  const userProxyKey = useSelector((state) => state.auth.proxyKey);
  const userProxyType = useSelector((state) => state.auth.proxyType);
  
  const [response, setResponse] = useState({});
  const [selectedUser, setSelectedUser] = useState(userProxyKey);

  useEffect(() => {
    fetchData();
  }, [showModal]);

  const fetchData = async () => {
    try {
      // const response = await MakeAxiosRequest("post", "/userlist",{user_proxy_key: userProxyKey,user_proxy_type: userProxyType});
      const response = await MakeAxiosRequest("post", "/getproxylist",{user_proxy_key: userProxyKey,user_proxy_type: userProxyType});
      if (response.status == 1) {
        setResponse(response.data);
      } else {
        console.log(response.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleUserSelect = (data) => {
    if(data.maxine_star=='1'){
      dispatch(switchProfile({key:data.user_proxy_key, type:data.user_proxy_type}));
      setSelectedUser(data.user_proxy_key);
      closeModal();
    }else{
      SwalError({ msg: response?.maxine_star_error_label || "This user is not currently a Maxine Star. To place service requests for this user, you need to be added as a Maxine Star. Use one of your available slots to become a Maxine Star and start placing requests." });
    }
    
  };

  return (
    <ModalBox
      isShow={showModal}
      handleClose={closeModal}
      modalSize="md select-user"
      hasData={response?.relationship}
    >
      <div className="text-center mb-4">
        <h3>Relationships</h3>
        {response.note_webapp && <span dangerouslySetInnerHTML={{ __html: response.note_webapp }} />}
      </div>
      {(response.customer_details || response.relationship) &&
      <div className="select-user">
        {response.customer_details && (
          <>
          <ListBox selectedUser={selectedUser} data={{...response.customer_details.user,relation_label:response.customer_details.user?.user_type_label}} onClick={handleUserSelect}/>
          {/* <div className="myself-sec mb-4" onClick={()=>handleUserSelect('')}>
            <div className="d-flex align-items-center mb-2 ms-1">
                      <img src={response.customer_details.user?.image_path} className="prfl-sec"></img>
                      <p className="mb-0">{response.customer_details.user?.name}</p>
                      <span className="span-tag">{response.customer_details.user?.user_type_label}</span>
                    </div>
          </div> */}
          </>
        )}
        {response.relationship?.map((list) =>  (
          <>
            <h5 className="mt-3">{list.title}</h5>
            {list.note && <p>{list.note}</p>}
            {list.relationusers.map((usr) => (
                <ListBox selectedUser={selectedUser} data={usr} onClick={handleUserSelect}/>
            ))}
          </>
        ))}
      </div>}
    </ModalBox>
  );
}

const ListBox = ({selectedUser, data, onClick}) => {

  const navigate = useNavigate();

  return (
    <div className="rdio rdio-primary radio-inline selection">
      {/* <div className={`membrshp-bill ${(selectedUser===data.user_proxy_key) ? 'select-rlshp' : ''} mb-2 justify-content-between`}  onClick={()=>onClick(data.user_proxy_key,data.user_proxy_type)}> */}
      <div className={`membrshp-bill mb-2 justify-content-between`}  onClick={()=>onClick(data)}>
        
        <div className="d-flex">
          <div className="rlshp-img  me-2">
            <img src={data.image_path} className="prfl-sec"></img>
            {data.show_tick_icon=='1' && <span><i className="fa-solid fa-check"></i></span>}
          </div>
          <div>
            <p className="mb-0">{data.name} {data.maxine_star && data.maxine_star=='1' && <i className="fa-solid fa-star ms-2 icon-primary"></i>}</p>
            {data.relation_label && <small className="white d-block">{data.relation_label}</small>}
          </div>
          
        </div>
        <div className="d-flex align-items-center">
          {data.permitted_via && <div><span className="tag-wp">Via {data.permitted_via}</span></div>}
          <a onClick={()=>navigate("/relationship/"+ (data.user_type==="myself" ? "myprofile" : data.user_proxy_key))}>
          <i className="fa-solid fa-circle-chevron-right white ms-2" ></i></a>
        </div>
        
      </div>
      
    </div>
  )
}
export default SelectUserModal;
